export const MAX_MOBILE_WIDTH = 600;
export const MAX_TABLET_WIDTH = 1279;

// This comment is added to trigger a new build hash without changing functionality.
